import { DefaultExecution } from './default-execution.model';
import { IDefaultExecutionWithCourseOfferingQuery } from '../interfaces/default-execution-with-course-offering.query.interface';
import { CourseRelevantExecution } from 'app/library/relevant-execution/models/course-relevant-execution.model';
import { CourseOffering } from 'app/library/course-offering/models/course-offering.model';

// @dynamic
export class DefaultExecutionWithCourseOffering {
    courseOffering: CourseOffering;
    defaultExecution: DefaultExecution;
    options: (CourseRelevantExecution | DefaultExecution)[];
    isLoading: boolean = false;
    hasLoadedOptions: boolean = false;

    constructor(query: IDefaultExecutionWithCourseOfferingQuery) {
        if (query) {
            this.courseOffering = new CourseOffering(query.course_offering);
            this.defaultExecution = query.default_execution ? new DefaultExecution(query.default_execution) : null;
        }
    }
}
